import { render, staticRenderFns } from "./StudipFileChooser.vue?vue&type=template&id=36a8b526&scoped=true&"
import script from "./StudipFileChooser.vue?vue&type=script&lang=js&"
export * from "./StudipFileChooser.vue?vue&type=script&lang=js&"
import style0 from "./StudipFileChooser.vue?vue&type=style&index=0&id=36a8b526&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36a8b526",
  null
  
)

export default component.exports